import clsx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PHONE_REGISTER_STATUS } from '../../constants/system.keys';
import './index.scss';

export const HeaderCall = ({ username, status }) => {
  const { t } = useTranslation();
  const getStatus = () => {
    if (status === PHONE_REGISTER_STATUS.ERROR) {
      return t('error');
    }

    if (status === PHONE_REGISTER_STATUS.READY) {
      return t('ready');
    }

    if (status === PHONE_REGISTER_STATUS.REGISTERING) {
      return t('registering');
    }

    return t('not ready');
  };

  return (
    <div className="header-status-phone">
      <span className="my-phone">{username}</span>
      <span
        className={clsx('status', {
          success: status === PHONE_REGISTER_STATUS.READY,
          registering: status === PHONE_REGISTER_STATUS.REGISTERING,
          error:
            status === PHONE_REGISTER_STATUS.ERROR ||
            status === PHONE_REGISTER_STATUS.UNSET,
        })}
      >
        {getStatus()}
      </span>
    </div>
  );
};

export default HeaderCall;
